import { extendTailwindMerge } from 'tailwind-merge'
import type { VariantProps } from 'tailwind-variants'
import { createTV } from 'tailwind-variants'

const config = {
  classGroups: {
    text: ['text', 'text-xxs'],
  },
}

export type { VariantProps }

export const customTwMerge = extendTailwindMerge<'text'>({
  extend: config,
})

const customTV = createTV({
  twMerge: true,
  twMergeConfig: config,
})

export default customTV
